import React from 'react';
import { copyFor, routes } from 'config';
import { Link, Text } from '@perch-labs/shrike';

const getCopy = copyFor('settings.moving');
const { dashboard } = routes();

interface Props {
  context: MovingStateMachineContext;
  matches: (state: string) => boolean;
}

export const ViewConfirmation = ({ matches, context }: Props) => {
  const { utility } = context;
  let copy;
  if (matches('getSetupReminder')) copy = getCopy('getSetupReminder');
  else if (matches('getOnlineSetupReminder'))
    copy = getCopy('getOnlineSetupReminder');
  else if (matches('viewConfirmation')) copy = getCopy('viewConfirmation');
  else copy = {};

  return (
    <div data-testid="view-all-set-confirmation">
      <Text textStyle="heading800" tag="h1" margin={{ bottom: '16px' }}>
        {copy.title}
      </Text>
      {copy.content.map(content => (
        <Text key={content} margin={{ bottom: '16px' }}>
          {content}
        </Text>
      ))}
      {utility.vnmEligible && (
        <Text margin={{ bottom: '16px' }}>{copy.contentVnm}</Text>
      )}
      <Link
        fullWidth={true}
        margin={{ top: '24px' }}
        to={dashboard}
        type="CTA"
        color="primaryInverse"
      >
        {copy.button}
      </Link>
    </div>
  );
};
